import styled from "styled-components";

export const StyledInputBox = styled.fieldset`

    display: flex;
    flex-direction: column;
    
    label{
        text-align: left;
        color: var(--color-grey-0);
        margin-bottom: 15px;
        font-size: 12.182px;
    }

    input{
        width: 100%;
        padding: 1rem;

        border: 1.2px solid var(--color-grey-1);
        border-radius: 4px;

        background-color: var(--color-grey-2);
        color: var(--color-grey-0);
        outline: none;
        transition: 0.3s ease;
    }

    input:focus{
        border: 1.2px solid var(--color-grey-0);
    }

    .invalidInput{
        border: 1.2px solid var(--color-negative);
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0;
    }
`